import { accentBaseColors, accentShades, accentTints, chartBaseColors, primaryBaseColors, primaryTints, secondaryBaseColors, secondaryTints, } from "./colors";
const lightTheme = {
    // Text
    $text: primaryBaseColors.navy,
    $textSoft: primaryTints.navy90,
    $textSubtle: primaryTints.navy80,
    $textSubtlest: primaryTints.navy50,
    $textDisabled: primaryTints.navy50,
    $textInverse: primaryBaseColors.cream,
    $textSelected: secondaryBaseColors.gold,
    $textDanger: accentShades.bloodOrange70,
    $textSuccess: accentShades.parakeetGreen50,
    $textAccentBlue: accentShades.steelBlue50,
    $textAccentGreen: accentShades.parakeetGreen50,
    $textWarning: accentBaseColors.amber,
    $textInfo: accentShades.steelBlue50,
    $cream: primaryBaseColors.cream,
    $navy: primaryBaseColors.navy,
    $textInProgress: accentShades.steelBlue50,
    $textWaiting: accentTints.amber90,
    // Links
    $link: accentShades.steelBlue50,
    $linkPressed: accentShades.powderBlue50,
    // Icons
    $icon: primaryBaseColors.navy,
    $iconInverse: secondaryBaseColors.gold,
    $iconDisabled: primaryTints.navy80,
    $iconSelected: accentShades.steelBlue90,
    $iconSoft: primaryTints.navy80,
    $iconSubtle: primaryTints.navy50,
    $iconPerformancePositive: accentShades.parakeetGreen50,
    $iconPerformanceNegative: accentShades.bloodOrange70,
    $iconDanger: accentShades.bloodOrange70,
    $iconSuccess: accentShades.parakeetGreen50,
    $iconWarning: accentBaseColors.amber,
    $iconInfo: accentShades.steelBlue50,
    $iconWaiting: accentTints.amber90,
    $iconInProgress: accentTints.steelBlue30,
    // Borders
    $border: primaryTints.navy10,
    $borderBold: secondaryTints.gold70,
    $borderInverse: primaryTints.navy80,
    $borderFocused: primaryBaseColors.navy,
    $borderInput: secondaryTints.gold50,
    $borderDisabled: primaryTints.navy30,
    $borderSelected: primaryBaseColors.navy,
    $borderDanger: accentShades.bloodOrange70,
    $borderWarning: accentBaseColors.amber,
    $borderInfo: accentShades.steelBlue50,
    // Backgrounds
    $backgroundSubtle: primaryTints.navy10,
    $backgroundSubtlest: primaryTints.navy05,
    $backgroundDisabled: primaryTints.navy30,
    $backgroundInverseSubtle: secondaryTints.gold20,
    $backgroundNeutral: "transparent",
    $backgroundNeutralHovered: primaryTints.navy10,
    $backgroundNeutralPressed: primaryTints.navy05,
    $backgroundNeutralBold: primaryBaseColors.navy,
    $backgroundNeutralBoldHovered: primaryTints.navy60,
    $backgroundNeutralBoldPressed: primaryTints.navy40,
    $backgroundNeutralSubtle: primaryTints.navy20,
    $backgroundNeutralSubtleHovered: primaryTints.navy10,
    $backgroundNeutralSubtlePressed: primaryTints.navy05,
    $backgroundSelected: primaryBaseColors.navy,
    $backgroundSelectedHovered: primaryTints.navy40,
    $backgroundSelectedPressed: primaryTints.navy30,
    $backgroundSelectedBold: accentBaseColors.parakeetGreen,
    $backgroundSelectedBoldHovered: primaryTints.navy80,
    $backgroundSelectedBoldPressed: "transparent",
    $backgroundSuccess: accentBaseColors.parakeetGreen,
    $backgroundInformation: accentTints.steelBlue80,
    $backgroundOverlay: secondaryTints.gold70,
    $backgroundAttention: accentBaseColors.bloodOrange,
    $backgroundAttentionInverse: accentBaseColors.parakeetGreen,
    $backgroundWaiting: accentTints.amber80,
    $backgroundCompleted: accentTints.parakeetGreen30,
    $backgroundInProgress: accentTints.steelBlue20,
    // Blanket
    $blanket: primaryBaseColors.cream,
    // Skeleton
    $skeleton: primaryTints.navy20,
    // Surfaces
    $surface: primaryBaseColors.cream,
    $surfaceLow: primaryTints.navy05,
    $surfaceMedium: secondaryTints.gold20,
    $surfaceHigh: primaryTints.navy20,
    $surfaceNeutral: primaryTints.navy80,
    // Charts
    $chartLinePrimary: accentShades.parakeetGreen50,
    $chartLineSecondary: accentBaseColors.steelBlue,
    $chartLineTertiary: primaryBaseColors.navy,
    $chartSegmentOne: accentBaseColors.parakeetGreen,
    $chartSegmentTwo: chartBaseColors.kleinBlue,
    $chartSegmentThree: chartBaseColors.sage,
    $chartSegmentFour: accentBaseColors.steelBlue,
    $chartSegmentFive: chartBaseColors.powderBlue,
    $chartSegmentSix: secondaryBaseColors.gold,
    // Avatars
    $avatarSteelBlue: accentTints.steelBlue40,
    $avatarParakeetGreen: accentTints.parakeetGreen40,
    $avatarPowderBlue: accentTints.powderBlue40,
};
export default lightTheme;
//# sourceMappingURL=lightValues.js.map